import { alpha, Theme } from '@mui/material';

export default {
    sectionWrapper: {
        borderTop: '1px solid',
        borderColor: (theme: Theme) => alpha(theme.palette.text.primary, 0.08),
        p: 1,
        alignItems: 'flex-start',
        '&:first-of-type': {
            borderTop: 'none',
        },
    },
    iconHolder: {
        height: '16px',
        width: '16px',
        mr: 1,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0,
    },
    termSection: {
        '&.expand': {
            '.term-section__header': {
                color: 'primary.main',
                fontWeight: 600,
                '&:hover': {
                    opacity: 0.75,
                    cursor: 'pointer',
                },
            },
        },
        '&.collapse': {
            '.term-section__header': {
                '&:hover': {
                    opacity: 0.75,
                    cursor: 'pointer',
                    color: 'primary.main',
                },
            },
            '& .term-section__items': {
                overflow: 'hidden',
                height: 0,
            },
        },
    },
};
